// src/components/ClockCard.js

import { useState, useEffect } from "react";

import { Box, VStack, Text, HStack, Button } from "@chakra-ui/react";





const ClockCard = ({ clock }) => {
  const { _id, name, type, currentTime } = clock;
  const isManual = type === "manual" || type === "sim";

  const [time, setTime] = useState(currentTime);

  const date = new Date(time);
  const dateFormatted = date.toLocaleDateString("en-GB", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric"
  });

  const timeFormatted = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit"
  });

useEffect(() => {
  if (!isManual) {
    const fetchNow = async () => {
      try {
        const res = await fetch(`https://clock.poc.mrc.ai/api/clocks/${_id}`);
        if (!res.ok) throw new Error("Failed to fetch initial time");
        const updated = await res.json();
        setTime(updated.currentTime);
      } catch (err) {
        console.error("Initial time fetch error:", err);
      }
    };

    fetchNow();

    const interval = setInterval(fetchNow, 60000);
    return () => clearInterval(interval);
  }
}, [isManual, _id]);

  const advance = async (amount, unit = "minutes") => {
    const payload = { amount, unit };
    console.log(`[Advance Clock] Clock: ${name} (${_id})`, payload);

    try {
      const res = await fetch(`https://clock.poc.mrc.ai/api/clocks/${_id}/advance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error("Failed to advance clock");
      const updated = await res.json();
      setTime(updated.currentTime);
    } catch (err) {
      console.error("Advance error:", err);
    }
  };

  return (
    <Box
      bg="black"
      p={2}
      borderRadius="md"
      shadow="md"
      w="175px"
      textAlign="center"
    >
      <VStack spacing={0}>
        <Text
          fontSize="xs"
          color="whiteAlpha.700"
          textTransform="uppercase"
          letterSpacing="wide"
        >
          {name}
        </Text>
        <Text
          fontSize="xs"
          color="gray.400"
          fontFamily="monospace"
        >
          {dateFormatted}
        </Text>
        <Text
          fontSize="lg"
          fontWeight="bold"
          color="green.300"
          fontFamily="'VT323', monospace"
          textShadow="0 0 6px rgba(0,255,0,0.5)"
        >
          {timeFormatted}
        </Text>

        {isManual && (
          <HStack spacing={1} pt={1}>
            <Button size="xs" onClick={() => advance(1, "minutes")}>+1m</Button>
            <Button size="xs" onClick={() => advance(1, "hours")}>+1h</Button>
            <Button size="xs" onClick={() => advance(1, "days")}>+1d</Button>
          </HStack>
        )}
      </VStack>
    </Box>
  );
};

export default ClockCard;
